<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card v-if="masterDetails">
          <h1 class="mb-3">لیست جلسات شما</h1>
          <b-row>
            <b-col cols="12" md="6">
              <p>
                درآمد محاسبه شده:
                <span class="text-primary">
                  {{
                    Intl.NumberFormat("en-US").format(masterDetails.sumPrice)
                  }}
                </span>
                تومان
              </p>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="12">
              <h2 class="mb-3">لیست جلسات رزرو شده</h2>
              <div
                class="d-flex align-items-center"
                style="flex-wrap: wrap !important"
              >
                <div
                  v-for="(item, index) in guidelineBadges"
                  :key="index"
                  class="mr-1 mb-md-3 mb-1 border px-1 rounded-pill d-flex align-items-center"
                  :style="`border-color: ${item.border} !important;`"
                >
                  <span
                    class="guideline-badge-color"
                    :style="`background-color: ${item.bg} !important`"
                  ></span>
                  <p style="white-space: nowrap" class="mb-0 ml-1">
                    {{ item.text }}
                  </p>
                </div>
              </div>
            </b-col>
            <b-col cols="12">
              <b-table
                ref="refUserListTable"
                class="position-relative"
                :items="schedulesList"
                responsive
                :fields="myTableColumns"
                primary-key="id"
                show-empty
                bordered
                striped
                empty-text="موردی موجود نیست!"
              >
                <template #cell(startDate)="data">
                  {{
                    new Date(data.item.startDate).toLocaleDateString("fa-IR", {
                      weekday: "long",
                    })
                  }}
                  -
                  {{
                    new Date(data.item.startDate).toLocaleDateString("fa-IR")
                  }}
                  - ساعت
                  {{
                    new Date(data.item.startDate).toLocaleTimeString("fa-IR", {
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                  }}
                </template>
                <template #cell(status)="data">
                  <div>
                    <span
                      class="border px-1 rounded-pill text-white"
                      :style="`border-color: ${
                        statusColors[data.item.status]
                      } !important; background-color: ${
                        statusColors[data.item.status]
                      } !important; white-space: nowrap`"
                    >
                      {{ scheduleStatuses[data.item.status] }}
                    </span>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
export default {
  async mounted() {
    await this.getMasterDetails();
    this.sendMasterSalaryDetailsRequest();
  },
  data() {
    return {
      isLoading: false,
      schedulesList: null,
      masterDetails: null,
      myTableColumns: [
        {
          key: "startDate",
          label: "تاریخ جلسه",
        },
        {
          key: "status",
          label: "وضعیت",
        },
      ],
      scheduleStatuses: {
        1: "در انتظار برگزاری",
        2: "غیبت استاد",
        3: "غیبت زبان آموز",
        4: "انجام شده",
        5: "قبول شده",
        6: "رد شده",
        7: "در حال برگزاری",
      },
      statusColors: {
        1: "#3B82F6",
        2: "#EAB308",
        3: "#EA580C",
        4: "#6B7280",
        5: "#16A34A",
        6: "#EF4444",
        7: "#A855F7",
      },
      guidelineBadges: [
        {
          text: "در انتظار برگزاری",
          border: "#3B82F6",
          bg: "#3B82F6",
        },
        {
          text: "در حال برگزاری",
          border: "#A855F7",
          bg: "#A855F7",
        },
        {
          text: "غیبت استاد",
          border: "#EAB308",
          bg: "#EAB308",
        },
        {
          text: "غیبت زبان آموز",
          border: "#EA580C",
          bg: "#EA580C",
        },
        {
          text: "انجام شده",
          border: "#6B7280",
          bg: "#6B7280",
        },
        {
          text: "قبول شده",
          border: "#16A34A",
          bg: "#16A34A",
        },
        {
          text: "رد شده",
          border: "#EF4444",
          bg: "#EF4444",
        },
      ],
      // scheduleStatuses: {
      //   PendingForHeld: 1,
      //   MasterWasAbsent: 2,
      //   StudentWasAbsent: 3,
      //   Done: 4,
      //   Passed: 5,
      //   Rejected: 6,
      //   InHeld: 7,
      //   Temp: 8,
      // },
    };
  },
  methods: {
    async getMasterDetails() {
      try {
        this.isLoading = true;
        let _this = this;
        let getMasterDetails = new GetUserByToken(_this);
        getMasterDetails.setRequestParam({
          id: _this.$route.params.id,
        });
        await getMasterDetails.fetch((res) => {
          _this.masterDetails = res.data;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async sendMasterSalaryDetailsRequest() {
      try {
        this.isLoading = true;
        let _this = this;
        let getMasterSalaryDetails = new GetMasterDetailsForMaster(_this);
        getMasterSalaryDetails.setRequestParam({
          id: _this.$route.params.id,
        });
        await getMasterSalaryDetails.fetch((res) => {
          _this.schedulesList = res;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BOverlay,
  },
};
import {
  GetMasterSalaryDetailsForMaster,
  GetMasterDetailsForMaster,
} from "@/libs/Api/MasterUserPayment";
import { GetUserByToken } from "@/libs/Api/Users";
import { BCard, BRow, BCol, BTable, BOverlay } from "bootstrap-vue";
</script>
<style scoped>
.guideline-badge-color {
  width: 1rem;
  height: 1rem;
  border-radius: 10000rem;
  display: inline-block;
}
</style>
